// elements/token-helpers.ts
import { elevation as el, spacing } from "./theming/design";
var withVariableAttribute = (attribute, variables, mappingFunction, host = false) => {
  return variables.reduce((acc, curr) => {
    acc[host ? `:host([${attribute}='${curr}'])` : `&[${attribute}='${curr}']`] = mappingFunction(curr);
    return acc;
  }, {});
};
var elevation = el;
var paddingAndMarginAttributes = (spc = spacing, host = false) => ({
  ...withVariableAttribute(
    "margin",
    Object.keys(spc),
    (size) => ({
      margin: spc[size]
    }),
    host
  ),
  ...withVariableAttribute(
    "padding",
    Object.keys(spc),
    (size) => ({
      padding: spc[size]
    }),
    host
  ),
  ...withVariableAttribute(
    "elevation",
    Object.keys(el),
    (elevationValue) => ({
      boxShadow: el[elevationValue]
    }),
    host
  )
});
export {
  elevation,
  paddingAndMarginAttributes,
  withVariableAttribute
};
